<template>
  <div>
    <v-row class="pa-0 mx-5 bg-D5EEED mt-3 mb-3" justify="center">
      <v-col cols="12" sm="12" md="12" lg="12" align-self="center">
        <v-row class="pa-0 ma-0">
          <v-col class="text-right" cols="12" xs="3" sm="3" md="3" lg="3">
            <v-avatar size="100">
              <v-img
                v-if="genderPerson(selectPatient.account_title_th) == 'หญิง'"
                max-height="155"
                max-width="155"
                :src="
                  require('@/assets/image/female_woman_person_people_avatar_icon_159366.png')
                "
              ></v-img>
              <v-img
                v-if="genderPerson(selectPatient.account_title_th) == 'ชาย'"
                max-height="155"
                max-width="155"
                :src="
                  require('@/assets/image/male_boy_person_people_avatar_icon_159358.png')
                "
              ></v-img>
            </v-avatar>
          </v-col>

          <v-col
            cols="12"
            xs="3"
            sm="3"
            md="3"
            lg="3"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20">
              {{ selectPatient.account_title_th || "" }}
              {{ selectPatient.first_name_th || "" }}
              {{ selectPatient.last_name_th || "" }}
            </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              HN : {{ selectPatient.HN }}
            </span>
          </v-col>
          <v-col
            cols="12"
            xs="3"
            sm="3"
            md="3"
            lg="3"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20">
              หมายเลขโทรศัพท์
            </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              {{ selectPatient.mobile }}
            </span>
          </v-col>

          <v-col
            cols="12"
            xs="3"
            sm="3"
            md="3"
            lg="3"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20"> หมู่เลือด </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              {{ selectPatient.blood }}
            </span>
          </v-col>

          <v-col
            cols="12"
            xs="2"
            sm="2"
            md="2"
            lg="2"
            class="d-flex flex-column justify-center align-end"
          >
          </v-col>
          <v-col
            cols="12"
            xs="1"
            sm="1"
            md="1"
            lg="1"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20"> เพศ </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              <!-- {{ selectPatient.account_title_th }} -->
              {{ genderPerson(selectPatient.account_title_th) }}
              <v-icon
                v-if="genderPerson(selectPatient.account_title_th) == 'หญิง'"
                >mdi-gender-female
              </v-icon>
              <v-icon
                v-if="genderPerson(selectPatient.account_title_th) == 'ชาย'"
                >mdi-gender-male
              </v-icon>
            </span>
          </v-col>

          <v-col
            cols="12"
            xs="3"
            sm="3"
            md="3"
            lg="2"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20">
              วัน เดือน ปีเกิด
            </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              {{ displayBirthDate(selectPatient.birth_date) }}
            </span>
          </v-col>

          <v-col
            cols="12"
            xs="1"
            sm="1"
            md="1"
            lg="1"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20"> ปี </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              {{ ageCalcilar(selectPatient.birth_date) }}
            </span>
          </v-col>
          <v-col
            cols="12"
            xs="3"
            sm="3"
            md="3"
            lg="3"
            class="d-flex flex-column justify-center"
          >
            <span class="pb-0 w-400 text-navy-50 font-20">
              หมายเลขบัตรประชาชน
            </span>
            <span class="pt-3 w-400 text-navy-50 font-20">
              {{ displayCID(selectPatient.cid) }}
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- <Pagination :totals="0" :isPage="page" @page="changePage" /> -->
  </div>
</template>

<script>
import moment from "moment";
// import HistoryCalling from "./HistoryCalling.vue";
import functioncryto from "@/services/encrypt.js";

export default {
  components: {},
  data() {
    return {
      selectedItem: "",
      showCurrent: null,
      selectPatient: {},
      total: 0,
      page: 1,
      totalCalling: 0,
      pageCalling: 1,
    };
  },
  computed: {
  },
  methods: {
    open(item) {
      this.selectPatient = item;
    },
    changeSelect(e) {
      if (e) this.showCurrent = this.itemHistory.find((obj) => obj._id === e);
      else this.showCurrent = null;
      // console.log(this.showCurrent);
    },

    displayBirthDate(date) {
      if (!date) return "-";
      return moment(date).locale("th").add(543, "years").format("DD MMMM YYYY");
    },

    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    ageCalcilar(birth) {
      const today = new Date();
      const birthDate = new Date(birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    genderPerson(account_title_th) {
      if (account_title_th) {
        if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
        if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
          return "หญิง";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background: #00a99d;
  color: white;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
.card_pr {
  padding-right: 12px;
}
.usageAndAdvice {
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  margin: 0px;
}
.noitems {
  height: 50vh;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.v-list-item-group .v-list-item--active {
  background: #4ba69d;
  color: #fff;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  background: #d5eeed;
}
</style>
